import React from 'react';
import { Section, SectionTitle, Lead, Statement } from '../Section';
import { clinicians, type Clinician } from '../../data/proposal';
function EntryCard({
  clinician,
  align
}: {
  clinician: Clinician;
  align: 'left' | 'right';
}) {
  return <li className={`flex items-center gap-3 rounded-xl border border-white/12 bg-white/[0.03] p-2.5 pr-4 ${align === 'right' ? 'lg:flex-row-reverse lg:pl-4 lg:pr-2.5 lg:text-right' : ''}`} data-id="element-192" data-mp="dzfdikmnqv47">
      <img src={clinician.portrait} alt="" className="h-11 w-11 shrink-0 rounded-full object-cover object-top" data-id="element-193" data-mp="3ib12kuj5ccjc" />
      <div className="min-w-0" data-id="element-194" data-mp="3rdjzyz45xwy7">
        <p className="truncate font-heading text-base leading-tight text-white" data-id="element-195" data-mp="3rc8zp99xf7bu">{clinician.name}</p>
        <p className="font-body text-[11px] uppercase tracking-[0.16em] text-white/40" data-id="element-196" data-mp="pbqrow879i">
          Entry point · {clinician.location}
        </p>
      </div>
    </li>;
}
const assets = ['Real clinicians', 'Real patients', 'Real clinical decisions', 'Real outcomes'];
export function OpportunitySection() {
  return <Section id="opportunity" index="02" label="The opportunity" data-id="element-197" data-mp="3o6k72ko0m37">
      <div className="grid gap-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-end lg:gap-16" data-id="element-198" data-mp="3vr635muye75f">
        <SectionTitle data-id="element-199" data-mp="3qy4mpaf3lzjq">
          Great content only works
          <br data-id="element-200" data-mp="3m0356txbm8ad" />
          when people enter it.
        </SectionTitle>
        <div data-id="element-201" data-mp="3lzte130jhv33">
          <Lead data-id="element-202" data-mp="3ly8u07bupujh">
            Solventum already has the valuable part. The opportunity is to create more entry points
            into it.
          </Lead>
          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-203" data-mp="3c0ub812ggto0">
            {assets.map(asset => <li key={asset} className="rounded-full border border-secondary/30 px-3.5 py-1.5 font-body text-sm text-secondary" data-id="element-204" data-mp="381bt1d20qwov">
                {asset}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="relative mt-8" data-id="element-205" data-mp="11a40ctbkofbz">
        <div className="absolute left-0 right-0 top-1/2 hidden h-px -translate-y-1/2 bg-gradient-to-r from-transparent via-white/15 to-transparent lg:block" aria-hidden="true" data-id="element-206" data-mp="11b5ljqmayi7f" />
        <div className="relative grid items-center gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-10" data-id="element-207" data-mp="1p6qt8zwwrnb0">
          <ul className="space-y-3" data-id="element-208" data-mp="1bfca8t303m3y">
            {clinicians.slice(0, 2).map(clinician => <EntryCard key={clinician.id} clinician={clinician} align="left" data-id="element-209" data-mp="1gdngyuy01ghy" />)}
          </ul>

          <div className="mx-auto flex h-40 w-40 shrink-0 flex-col items-center justify-center rounded-full border border-primary/45 bg-[#02241e] px-5 text-center shadow-[0_0_0_10px_rgba(1,51,43,1)]" data-id="element-210" data-mp="242yg67zpb2tz">
            <p className="font-body text-[10px] uppercase tracking-[0.18em] text-secondary/70" data-id="element-211" data-mp="1u40sf7a3ndc1">
              One content hub
            </p>
            <p className="mt-1.5 font-heading text-xl leading-tight text-white" data-id="element-212" data-mp="ipde6dqe2ops">
              Filtek Clinical Cases
            </p>
            <p className="mt-2 font-body text-xs text-white/45" data-id="element-213" data-mp="np89qul402h6">The destination</p>
          </div>

          <ul className="space-y-3" data-id="element-214" data-mp="g3meid3q599s">
            {clinicians.slice(2).map(clinician => <EntryCard key={clinician.id} clinician={clinician} align="right" data-id="element-215" data-mp="b4jcz2mydl6k" />)}
          </ul>
        </div>
        <p className="mt-5 text-center font-body text-[11px] uppercase tracking-[0.2em] text-white/35" data-id="element-216" data-mp="p4u6kdfnddvf">
          Multiple clinician-led entry points
        </p>
      </div>

      <div className="mt-8 grid gap-6 border-t border-white/10 pt-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-217" data-mp="3sn47np1jo6iy">
        <p className="font-body text-base leading-relaxed text-white/60" data-id="element-218" data-mp="3olsdd67q6x4f">
          Instead of promoting one large clinical-case experience, we create a series of highly
          focused reasons to enter it.
        </p>
        <Statement data-id="element-219" data-mp="1egmpa77ulbx">
          Don’t ask HCPs to discover the cases. Give them a case they want to discover.
        </Statement>
      </div>
    </Section>;
}